import Base from "./modules/base.js";
import Product from "./modules/product";
let routes = [...Base, ...Product, {
  path: '/:catchAll(.*)',
  redirect: '/index',
  hidden: true,
}];

export default routes;
